import { useEffect, useState } from "react";
import { CashReimbursementServices } from "../../erp/cellEditor/CashDesk/CashReimbursement/CashReimbursement-service";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../theme/Component/PrintJson";
import { BasicMultiSelectTable } from "../../theme/Component/BasicMultiSelecTable";
import useModal, { MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { BasicTable } from "../../theme/Component/BasicTable";

interface Props {
    label: string;
    onChange: Function;
    id?: any;
    filterDocument?:any[]
}
export const SelectorDocumentFactory = ({ label, onChange,filterDocument }: Props) => {

    const service = new CashReimbursementServices();
    const [lista, setLista] = useState<any>([]);
    const [original, setOriginal] = useState<any>([]);
    const [listaResultado, setListaResultado] = useState<any>([]);
    const modal = useModal("Tipo Documento", MODAL_md);
    const [option, setOption] = useState<any>({});
    const [txt, setTXT] = useState<string>('');

    useEffect(() => {
        getDocumentFactoryCatalog();

    }, [])
    useEffect(() => {
        onChange(option);
        modal.close();
    }, [option])

    useEffect(()=>{
        if(filterDocument)
        {
            let temp = [];
            original.forEach(element => {                
                if(filterDocument.includes(element.DataBeanProperties.Mnemonic))
                {
                    temp.push(element);
                }
            });
            setLista(temp);
        }
    },[original,filterDocument])

    const getDocumentFactoryCatalog = () => {

        let temp = _single.getCacheItem('Mnemonic');
        if (temp) {
            setLista(temp);
            setOriginal(temp);
        } else {
            _single.spinner(true);
            service.getDocumentFactoryCatalog(null).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ObjectValue) {
                        let temp = resp.DataBeanProperties.ObjectValue.filter((item: any) => item.DataBeanProperties.Mnemonic != null);
                        setLista(temp);
                        setOriginal(temp);
                        _single.setCacheItem('Mnemonic', temp);
                    }
                    _single.spinner(false);
                }
            );
        }

    }

    const buscarTipo=()=>{
        if(txt==''){
            setLista(original); 
        }
        else if(txt.length>1){                          
            let temp=original.filter((item:any)=>item.DataBeanProperties.Mnemonic.toLowerCase().includes(txt.toLowerCase()));
            console.log(temp);

            if(temp.length==0){
                setLista(original);
            }else{
                setLista(temp);
            }
            
        }
    }

    const head = [
        // { title: 'ID', property: 'IDDocumentFactory', visible: false },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
    ]

    return (
        <div className="row">
            <div className="col">
                {label != '' && <label>{label}</label>}
                <input type="text" className="form-control" value={`${option.Mnemonic ?? "Seleccionar"}`} readOnly onClick={() => { modal.open() }} />
                <Modal modal={modal.modal} updateModal={modal.setModal}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group">
                                <input type="text" className="form-control" aria-label="Buscar"  aria-describedby="button-addon2" value={txt} onChange={(e)=>{setTXT(e.target.value)}}/>
                                    <button className="btn btn-outline-success shadow-none" type="button" id="button-addon2" onClick={buscarTipo}>Buscar</button>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} rowSet={setOption}></BasicTable>

                        </div>
                    </div>

                </Modal>
            </div>
        </div>
    )
}